import { STATS, STATS_TAGLINE } from "../../data/collection";
import { Reveal } from "./Reveal";

export default function Stats() {
  return (
    <section
      data-testid="stats"
      className="relative overflow-hidden bg-[#050505] text-white border-t border-white/10"
    >
      <div className="kln-noise" />
      <div className="relative mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="grid gap-12 md:grid-cols-12 md:items-center">
          <div className="md:col-span-7">
            <div className="grid grid-cols-3 gap-6 md:gap-10">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.08}>
                  <div className="border-t border-white/15 pt-5">
                    <p className="font-display text-4xl md:text-6xl font-light leading-none">
                      {s.value}
                    </p>
                    <p className="mt-3 font-body text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-white/50">
                      {s.label}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
          <div className="md:col-span-5">
            <Reveal delay={0.15}>
              <p className="font-serif-editorial text-2xl md:text-3xl font-light italic leading-snug text-white/80">
                &ldquo;{STATS_TAGLINE}&rdquo;
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
